var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"dark-aqua",attrs:{"icon":"el-icon-document"},on:{"click":_vm.goStatusResult}},[_vm._v("検査結果を見る")])}
var staticRenderFns = []

export { render, staticRenderFns }